const rnd = (i, s = 1) => { const x = Math.sin(i * 127.1 + s * 311.7) * 43758.5453; return x - Math.floor(x); };
const n = (e, mobile) => Math.max(1, Math.round(e.count * (mobile ? 0.5 : 1)));
const list = (e, mobile) => Array.from({ length: n(e, mobile) }, (_, i) => i);

const Flyer = ({ i, e, dur, top, children, seed }) => {
  const d = dur / e.speed;
  const delay = `-${(rnd(i, seed) * d).toFixed(1)}s`;
  return (
    <span className="lg-abs" style={{ top: `${top}%`, left: 0, animation: `lg-fly-x ${d}s linear ${delay} infinite ${i % 2 ? "reverse" : "normal"}` }}>
      <span className="lg-abs" style={{ position: "relative", animation: `lg-fade ${d}s linear ${delay} infinite` }}>
        <span className="lg-abs" style={{ position: "relative", animation: `lg-bob ${3 + rnd(i, seed + 2) * 3}s ease-in-out infinite` }}>{children}</span>
      </span>
    </span>
  );
};

export const Ghosts = ({ e, mobile }) => list(e, mobile).map((i) => {
  const w = (28 + rnd(i, 3) * 34) * e.size;
  return (
    <Flyer key={i} i={i} e={e} dur={22 + rnd(i, 4) * 16} top={12 + rnd(i, 5) * 70} seed={1}>
      <svg width={w} height={w * 1.15} viewBox="0 0 40 46" style={{ opacity: e.opacity, filter: "drop-shadow(0 0 10px rgba(147,197,253,.85))" }}>
        <path d="M20 2C9 2 2 10 2 21v23l6-5 6 5 6-5 6 5 6-5 6 5V21C38 10 31 2 20 2z" fill={e.color} />
        <ellipse cx="14" cy="19" rx="2.6" ry="3.6" fill="#1f2937" /><ellipse cx="26" cy="19" rx="2.6" ry="3.6" fill="#1f2937" />
        <ellipse cx="20" cy="29" rx="3" ry="2" fill="#1f2937" opacity=".6" />
      </svg>
    </Flyer>
  );
});

export const Bats = ({ e, mobile }) => list(e, mobile).map((i) => {
  const w = (30 + rnd(i, 6) * 30) * e.size;
  return (
    <Flyer key={i} i={i + 1} e={e} dur={12 + rnd(i, 7) * 10} top={6 + rnd(i, 8) * 45} seed={2}>
      <svg width={w} height={w / 2.6} viewBox="0 0 60 23" style={{ opacity: e.opacity, animation: `lg-flap ${0.25 + rnd(i, 9) * 0.2}s ease-in-out infinite`, transformOrigin: "center" }}>
        <path d="M0 9Q10 0 20 7Q25 1 30 7Q35 1 40 7Q50 0 60 9Q50 8 45 14Q38 10 30 18Q22 10 15 14Q10 8 0 9z" fill={e.color} />
        <circle cx="30" cy="10" r="4" fill={e.color} />
      </svg>
    </Flyer>
  );
});

export const Moon = ({ e }) => (
  <span className="lg-abs" style={{ top: 96, right: 24, width: 74 * e.size, height: 74 * e.size, borderRadius: "50%", opacity: e.opacity,
    background: `radial-gradient(circle at 35% 35%, #fffef5, ${e.color} 60%, #d6cf9a)`, boxShadow: `0 0 40px 10px ${e.color}55` }} />
);

export const Fog = ({ e }) => (
  <span className="lg-abs" style={{ left: "-10%", right: "-10%", bottom: 0, height: "32vh", opacity: e.opacity, filter: "blur(18px)",
    background: `radial-gradient(ellipse at 20% 80%, ${e.color}, transparent 60%), radial-gradient(ellipse at 70% 90%, ${e.color}, transparent 55%)`,
    animation: `lg-fog ${18 / e.speed}s ease-in-out infinite alternate` }} />
);

export const Pumpkins = ({ e, mobile }) => (
  <span className="lg-abs" style={{ bottom: 6, left: mobile ? 84 : 104, display: "flex", gap: 6, opacity: e.opacity }}>
    {list(e, mobile).map((i) => (
      <svg key={i} width={(34 + (i % 2) * 8) * e.size * (mobile ? 0.8 : 1)} viewBox="0 0 40 36" style={{ animation: `lg-bob ${3 + i}s ease-in-out infinite` }}>
        <path d="M20 6c3-4 6-5 8-4-2 1-4 3-5 6" stroke="#166534" strokeWidth="3" fill="none" />
        <ellipse cx="20" cy="22" rx="18" ry="13" fill={e.color} /><ellipse cx="20" cy="22" rx="7" ry="13" fill="#000" opacity=".12" />
        <path d="M11 18l4 3-4 1zM29 18l-4 3 4 1zM12 27q8 5 16 0l-3 1-2-2-3 2-3-2-2 2z" fill="#fde68a" />
      </svg>
    ))}
  </span>
);

const Web = ({ e, flip }) => (
  <svg width={130 * e.size} height={130 * e.size} viewBox="0 0 100 100" className="lg-abs" style={{ top: 80, [flip ? "right" : "left"]: 0, opacity: e.opacity, transform: flip ? "scaleX(-1)" : "none" }}>
    <g stroke={e.color} strokeWidth=".8" fill="none">
      {[0, 22, 45, 68, 90].map((a) => <line key={a} x1="0" y1="0" x2={100 * Math.cos((a * Math.PI) / 180)} y2={100 * Math.sin((a * Math.PI) / 180)} />)}
      {[20, 40, 60, 80].map((r) => <path key={r} d={`M${r} 0 Q${r * 0.75} ${r * 0.3} ${r * 0.7} ${r * 0.7} Q${r * 0.3} ${r * 0.75} 0 ${r}`} />)}
    </g>
  </svg>
);
export const Webs = ({ e }) => (<><Web e={e} />{e.count > 1 && <Web e={e} flip />}</>);

const Twinkles = ({ e, mobile, shape, seed }) => list(e, mobile).map((i) => {
  const s = (8 + rnd(i, seed) * 14) * e.size;
  return (
    <span key={i} className="lg-abs" style={{ top: `${8 + rnd(i, seed + 1) * 84}%`, left: `${rnd(i, seed + 2) * 96}%`,
      animation: `lg-twinkle ${(2.5 + rnd(i, seed + 3) * 3) / e.speed}s ease-in-out -${(rnd(i, seed + 4) * 4).toFixed(1)}s infinite` }}>
      <svg width={s} height={s} viewBox="0 0 20 20" style={{ opacity: e.opacity }}>
        {shape === "dot" ? <circle cx="10" cy="10" r="5" fill={e.color} style={{ filter: `drop-shadow(0 0 6px ${e.color})` }} />
          : shape === "star" ? <path d="M10 0l3 7 7 .5-5.5 4.5 2 7L10 15l-6.5 4 2-7L0 7.5 7 7z" fill={e.color} />
            : <path d="M10 0l2 8 8 2-8 2-2 8-2-8-8-2 8-2z" fill={e.color} />}
      </svg>
    </span>
  );
});
export const Sparks = (p) => <Twinkles {...p} shape="dot" seed={11} />;
export const Stars = (p) => <Twinkles {...p} shape="star" seed={21} />;
export const Sparkles = (p) => <Twinkles {...p} shape="spark" seed={31} />;

const Faller = ({ i, e, seed, dur, children, spin }) => {
  const d = (dur + rnd(i, seed) * dur) / e.speed;
  return (
    <span className="lg-abs" style={{ top: 0, left: `${rnd(i, seed + 1) * 100}%`, animation: `lg-fall ${d}s linear -${(rnd(i, seed + 2) * d).toFixed(1)}s infinite` }}>
      <span className="lg-abs" style={{ position: "relative", animation: `${spin ? "lg-spin" : "lg-sway"} ${2 + rnd(i, seed + 3) * 3}s ${spin ? "linear" : "ease-in-out"} infinite` }}>{children}</span>
    </span>
  );
};

export const Snow = ({ e, mobile }) => list(e, mobile).map((i) => {
  const s = (6 + rnd(i, 41) * 12) * e.size;
  return (
    <Faller key={i} i={i} e={e} seed={42} dur={9}>
      {i % 3 ? <svg width={s} height={s} viewBox="0 0 10 10" style={{ opacity: e.opacity * (0.5 + rnd(i, 43) / 2) }}><circle cx="5" cy="5" r="4" fill={e.color} /></svg>
        : <svg width={s * 1.6} height={s * 1.6} viewBox="0 0 24 24" style={{ opacity: e.opacity }}><g stroke={e.color} strokeWidth="1.6" strokeLinecap="round">
          {[0, 60, 120].map((a) => <line key={a} x1="12" y1="2" x2="12" y2="22" transform={`rotate(${a} 12 12)`} />)}</g></svg>}
    </Faller>
  );
});

const PALETTE = ["#ef4444", "#22c55e", "#3b82f6", "#ffffff", "#f472b6"];
export const Confetti = ({ e, mobile }) => list(e, mobile).map((i) => (
  <Faller key={i} i={i} e={e} seed={51} dur={7} spin>
    <span style={{ display: "block", width: 8 * e.size, height: 14 * e.size, opacity: e.opacity, borderRadius: 2, background: i % 3 ? PALETTE[i % PALETTE.length] : e.color }} />
  </Faller>
));

export const Fireworks = ({ e, mobile }) => list(e, mobile).map((i) => {
  const s = (90 + rnd(i, 61) * 90) * e.size * (mobile ? 0.7 : 1);
  const color = i % 2 ? e.color : PALETTE[i % PALETTE.length];
  return (
    <svg key={i} width={s} height={s} viewBox="-50 -50 100 100" className="lg-abs" style={{ top: `${10 + rnd(i, 62) * 40}%`, left: `${5 + rnd(i, 63) * 80}%`, opacity: e.opacity,
      animation: `lg-burst ${3 / e.speed}s ease-out ${(i * 1.3).toFixed(1)}s infinite` }}>
      <g stroke={color} strokeWidth="2.4" strokeLinecap="round">
        {Array.from({ length: 12 }, (_, k) => <line key={k} x1="0" y1="-14" x2="0" y2="-46" transform={`rotate(${k * 30})`} />)}
      </g>
    </svg>
  );
});

export const Lights = ({ e, mobile }) => {
  const count = mobile ? 12 : 28;
  const colors = ["#ef4444", "#22c55e", e.color, "#ffffff"];
  return (
    <span className="lg-abs" style={{ top: 80, left: 0, right: 0, height: 34, opacity: e.opacity }}>
      <svg width="100%" height="14" preserveAspectRatio="none" viewBox="0 0 100 14" className="lg-abs" style={{ top: 0 }}>
        <path d={Array.from({ length: count }, (_, k) => `${k ? "" : "M0 2 "}Q${((k + 0.5) * 100) / count} 12 ${((k + 1) * 100) / count} 2`).join(" ")} stroke="#1f2937" strokeWidth=".6" fill="none" vectorEffect="non-scaling-stroke" />
      </svg>
      <span style={{ display: "flex", justifyContent: "space-around", paddingTop: 6 }}>
        {Array.from({ length: count }, (_, k) => (
          <span key={k} style={{ width: 9 * e.size, height: 13 * e.size, borderRadius: "50% 50% 45% 45%", background: colors[k % 4], boxShadow: `0 0 10px 2px ${colors[k % 4]}`,
            animation: `lg-blink ${1.6 / e.speed}s ease-in-out ${(k % 4) * 0.4}s infinite` }} />
        ))}
      </span>
    </span>
  );
};

const Reindeer = ({ x }) => (
  <g transform={`translate(${x} 0)`} fill="#8b5a2b">
    <ellipse cx="20" cy="22" rx="15" ry="7" /><circle cx="37" cy="13" r="5" /><path d="M36 8l-3-7M38 8l3-7M33 3l-3-1M41 3l3-1" stroke="#8b5a2b" strokeWidth="1.6" />
    <path d="M10 27l-3 9M16 28l1 8M25 28l-1 8M31 27l4 8" stroke="#8b5a2b" strokeWidth="2.4" strokeLinecap="round" />
  </g>
);
export const Santa = ({ e, mobile }) => {
  const w = 320 * e.size * (mobile ? 0.6 : 1);
  return (
    <span className="lg-abs" style={{ top: mobile ? 118 : 130, left: 0, opacity: e.opacity, animation: `lg-santa ${26 / e.speed}s linear 2s infinite` }}>
      <svg width={w} height={w * 0.25} viewBox="0 0 320 80">
        {[0, 1, 2, 3, 4].map((k) => <path key={k} d="M5 0l2 5 5 .4-4 3 1.5 5L5 11l-4.5 2.4L2 8.4l-4-3 5-.4z" fill="#facc15" transform={`translate(${-20 - k * 18} ${30 + (k % 2) * 12}) scale(${1 - k * 0.12})`} style={{ animation: `lg-blink 0.8s ease-in-out ${k * 0.15}s infinite` }} />)}
        <path d="M150 30 Q120 25 90 32 M150 32 Q160 30 180 40" stroke="#d6b36a" strokeWidth="1.2" fill="none" />
        <Reindeer x={190} /><Reindeer x={250} /><circle cx="291" cy="13" r="3" fill="#ef4444" style={{ animation: "lg-glow 1s infinite" }} />
        <path d="M40 40h90q12 0 12-12v-6h8v8q0 22-22 22H52q-14 0-18-12z" fill={e.color} /><path d="M30 58h110" stroke="#D4AF37" strokeWidth="4" strokeLinecap="round" />
        <circle cx="86" cy="12" r="9" fill="#fcd9b6" /><path d="M76 10q10-16 22-2z" fill={e.color} /><circle cx="99" cy="6" r="3" fill="#fff" />
        <path d="M76 18q10 10 20 0v6q-10 6-20 0z" fill="#fff" /><rect x="72" y="22" width="30" height="20" rx="6" fill={e.color} />
        <rect x="58" y="22" width="16" height="14" rx="2" fill="#16a34a" /><rect x="64" y="22" width="3" height="14" fill="#D4AF37" />
      </svg>
    </span>
  );
};

export const Tree = ({ e, mobile }) => {
  const w = 74 * e.size * (mobile ? 0.8 : 1);
  return (
    <svg width={w} height={w * 1.3} viewBox="0 0 60 78" className="lg-abs" style={{ right: 14, bottom: mobile ? 92 : 104, opacity: e.opacity }}>
      <path d="M30 6L8 34h10L4 54h14L2 70h56L42 54h14L42 34h10z" fill={e.color} /><rect x="25" y="70" width="10" height="8" fill="#7c4a1e" />
      <path d="M30 0l2.4 5.6 6 .5-4.6 3.9 1.4 5.9L30 12.8l-5.2 3.1 1.4-5.9-4.6-3.9 6-.5z" fill="#facc15" style={{ animation: "lg-glow 1.6s ease-in-out infinite" }} />
      {[[22, 30, "#ef4444"], [36, 40, "#facc15"], [18, 50, "#3b82f6"], [40, 58, "#ef4444"], [26, 62, "#fff"], [32, 24, "#fff"], [14, 64, "#facc15"]].map(([x, y, c], k) => (
        <circle key={k} cx={x} cy={y} r="2.6" fill={c} style={{ animation: `lg-blink 1.4s ease-in-out ${k * 0.25}s infinite` }} />
      ))}
    </svg>
  );
};

export const EFFECTS = { ghosts: Ghosts, bats: Bats, fog: Fog, moon: Moon, pumpkins: Pumpkins, webs: Webs, sparks: Sparks,
  snow: Snow, lights: Lights, santa: Santa, tree: Tree, stars: Stars, confetti: Confetti, fireworks: Fireworks, sparkles: Sparkles };
